import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { HttpResponseValidation } from './http-error';
import { HttpStatusEnum } from './http-status';
import { AuthenticationService } from '../auth/authentication.service';
import { NotificationService } from '../services/notification.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private notificationService: NotificationService,
    private authenticationService: AuthenticationService) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(null, (err: any) => {
        console.log(err)
        if (request.url.indexOf('/api/auth') == -1) {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
              this.authenticationService.logout(true);
              this.notificationService.error('Ops...', 'Sua sessão expirou, faça login novamente.');
            }
            if (err.status === 413) {
              this.notificationService.error('Ops...', 'A imagem que você está tentando enviar é muito grande, tente enviar uma imagem menor.');
            }
            else {
              if (request.params && request.params.has('ignoreError')) {

              }
              else if (err.status == 0) {
                this.notificationService.error('Ops...', 'Verifique a sua conexão com a internet ou aguarde um momento e tente novamente');
              }
              else {
                this.tratar(err, request);
              }
            }
          }
        }
      })
    )
  }

  private tratar(err: HttpErrorResponse, request: HttpRequest<any>) {
    if (err.statusText == 'Unknown Error') {
      this.notificationService.error('Ops...', 'Ocorreu um erro inesperado durante esta ação.');
    } else {
      let errorObj = err.error;
      if (request.responseType == 'arraybuffer') {
        if ('TextDecoder' in window) {
          const dataView = new DataView(err.error);
          const decoder = new TextDecoder('utf8');
          errorObj = JSON.parse(decoder.decode(dataView));
        } else {
          const decodedString = String.fromCharCode.apply(null, <any>new Uint8Array(err.error));
          errorObj = JSON.parse(decodedString);
          const errorResponse = <HttpResponseValidation>errorObj;
          const messages = errorResponse.mensagem.map(x => x + '<br>').toString();
          this.notificationService.error('Atenção', messages);
        }
      }
      else if (request.responseType == 'blob') {
        const reader = new FileReader();
        reader.onload = (ev: any) => {
          const errorResponse = <HttpResponseValidation>JSON.parse(ev.target.result);
          // const messages = errorResponse.mensagem.map(x => x + '<br>').toString();
          const messages = errorResponse.mensagem.toString();
          this.notificationService.error('Atenção', messages);
          // console.log('Error', messages)
        };
        reader.readAsText(errorObj);
      }

      else if (err.statusText == 'Unknown Error' || err.status == HttpStatusEnum.Accepted) {
        this.notificationService.error('Ops...', 'Ocorreu um erro inesperado durante esta ação.');
      }

      else if (err.status != HttpStatusEnum.NotFound) {
        const errorResponse = <any>err.error;
        let messages: any = errorResponse.mensagem ?? errorResponse.detail;

        if (Array.isArray(errorResponse.mensagem)) {
          messages = errorResponse.mensagem.map((x: any) => x + '<br>').toString();
        }

        if (errorResponse.camposInvalidos) {
          if (Array.isArray(errorResponse.camposInvalidos)) {
            const camposInvalidosMessages = errorResponse.camposInvalidos.map((campoInvalido: any) => {
              return `${campoInvalido.mensagem}`;
            });
            messages = `${messages}<br>${camposInvalidosMessages.join('<br>')}`;
          } else if (typeof errorResponse.camposInvalidos === 'string') {
            messages = `${messages}<br>${errorResponse.camposInvalidos}`;
          }
        }

        if (this.authenticationService.isLoged) {
          this.notificationService.error('Atenção', messages);
        }
      }

    }
  }
}
